import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const BEEEModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Delta-star and Star-delta', path: '/beee-m1-s1' },
      { name: 'Thevenin, Mesh and Nodal Analysis', path: '/beee-m1-s2' },
      { name: 'Super position and Maximum power transformation', path: '/beee-m1-s3' }
    ],
    'Module 2': [
      { name: 'Single Phase RLC series circuit and Three Phase', path: '/beee-m2-s1' }
    ],
    'Module 3': [
      { name: 'Magnetic Circuits', path: '/beee-m3-s1' },
      { name: 'Self and Mutual Inductance and Transformers', path: '/beee-m3-s2' }
    ],
    'Module 4': [
      { name: 'Electrical Machines', path: '/beee-m4-s1' }
    ],
    'Module 5': [
      {
        name: 'Digital Systems ',
        path: '/beee-m5-s1'
      },
      {
        name: 'K-map, Boolean, Logic gates, Adder, Multiplexer, Demultiplexer',
        path: '/beee-m5-s2'
      }
    ],
    'Module 6': [
      { name: 'Semiconductor Devices and Applications', path: '/beee-m6-s1' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Basic Engineering (refer to module 1, module 2, module 4 contents for your current module 1 & refer to module 6 for module 2)</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-BEEEModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BEEEModules;
